import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import WebbLoader from "./webb-loader";

import VaultDocsOverview from "./vault-docs-overview";

import { GetAuthUser } from "../services/user-accounts";
import { CheckDocsDetail } from "../services/user-vault";


const stat = [
  {code:"Pending", colr:"warning"},
  {code:"Active", colr:"success"},
  {code:"Expired", colr:"danger"},
  {code:"Inactive", colr:"lite"},
]

export default function VaultDocsCheckModule() {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(false);
  const [docs,setDocs]=useState({srch:''});
  const [data,setData]=useState({});
  const [form, setForm] = useState(false);
  const [text, setText] = useState('');

  // form validation
  useEffect( () => {
    setForm(false)
    if (docs.srch !=='') 
      setForm(true);
  },[docs.srch]);

  const handleChange = async(key, val) => {
    setDocs({ ...docs, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    setData( (await CheckDocsDetail(JSON.stringify({
      body: {crid: docs.srch, usid: asset.usid, form: asset.form},
      user: {usid: asset.usid, form: asset.form}
    }))).data)

    setLoading(false);
  }


  return (
    <>
    {console.log (data)}
      <form onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label small">Transcation Input Data (Blockchain) <span className="text-danger">*</span></label>
          <input 
            type="search"     
            className="form-control height-md"   
            value={docs.srch}
            onChange={({ target }) => {handleChange("srch", target.value); setText('');}}
            placeholder="0x0123456789">
          </input>
        </div>

        <div className="">
          <div className="d-grid">
            <button className={`btn height-md ${ form ? 'btn-primary' : 'btn-light'}`}
              disabled={!form}
            ><small>Search</small>
            </button>
          </div>
        </div>

      </form>

      <div className="py-3"><hr></hr></div>

      <p className="lead fw-bold">Search Results</p>
      <div className={loading ? '' : 'd-none'}>
        <p>Please Wait...</p>
      </div>

      <div className={loading ? 'd-none' : ''}>

        <div className="rounded border p-3 bg-white">
          <p>Name: {data.name}</p>
          <p>Number: {data.nmbr}</p>
          <p>Status: {data.stat}</p>

          <img src={data.file} alt='...' className="img-fluid" ></img>
        </div>

      </div>

    </>
  )
}